import { BadgeCheck, Handshake, MessageCircle } from "lucide-react";

const ITEMS = [[BadgeCheck, "Asesoría sin costo"], [Handshake, "Sin compromiso"], [MessageCircle, "Atención personalizada por WhatsApp"]];

export const TrustBand = () => (
  <section aria-label="Por qué elegirnos" data-testid="trust-band" className="bg-[#0B3C5D] text-white">
    <ul className="mx-auto grid max-w-6xl gap-5 px-4 py-8 sm:grid-cols-3 sm:px-6 sm:py-10">
      {ITEMS.map(([I, t]) => (
        <li key={t} className="flex items-center gap-3 text-[18px] font-semibold">
          <I className="h-7 w-7 shrink-0 text-[#5FD3C6]" aria-hidden="true" />{t}
        </li>
      ))}
    </ul>
  </section>
);
